<template>
  <div class="vip_home">
    <Fontnavbar title="立即领卡" />
    <div class="make_vip_warp">
      <div class="make_vip">
        <img src="/static/VIP_bj.png" alt="" class="img_bj">
        <div class="input_box">
          <van-field v-model="phone_num" type="number" maxlength="11" placeholder="手机号" />
          <van-field v-model="pass_num" type="password" placeholder="密码" />
        </div>
        <img src="/static/collect_card.png" alt="" class="img_btn" @click="getVip">
      </div>
    </div>
  </div>
</template>

<script>
import { checkVip } from "../../api.js";
import { post } from "../../request.js";
import Fontnavbar from "../../components/Navbar.vue";

import {
  Field,
  Toast
} from "vant";

export default {
  components: {
    [Field.name]: Field,
    [Toast.name]: Toast,
    Fontnavbar
  },

  data() {
    return {
      phone_num: '',
      pass_num: ''
    };
  },

  created() {
  },

  methods: {
    getVip() {
      var reg = /^1\d{10}$/g
      if (!this.phone_num || !this.pass_num) {
        Toast("手机号或者密码不能为空");
      } else if (!reg.test(this.phone_num)) {
        Toast("手机号码格式不正确");
      } else {

        post(checkVip, {
          phone:this.phone_num,
          password:this.pass_num,
        }).then((res) => {
          if (res.code == 200){
            this.$router.push('/vip/become_vip')
          }else{
            Toast(res.msg)
          }
        })
      }
    }
  }
};
</script>

<style lang="less" scoped>
.vip_home {
  .make_vip_warp {
    padding: 20px 12px;
    .make_vip {
      position: relative;
      height: 360px;
      > img,
      .input_box {
        position: absolute;
      }
      .img_bj {
        width: 100%;
        height: 360px;
      }
      .img_btn {
        width: 56%;
        bottom: 28px;
        left: 22%;
      }
      .input_box {
        width: 60%;
        bottom: 130px;
        left: 20%;
        > div:nth-of-type(1) {
          margin-bottom: 10px;
        }
      }
    }
  }
}
</style>
